import styled from "styled-components";
import { FormControl } from "react-bootstrap";

export default styled(FormControl)`
    width: ${props => props.width || 90}px !important;
`;
